// src/controllers/nav-bar_controller.js
import { Controller } from "stimulus";
import $ from "cash-dom";

export default class extends Controller {
  static targets = ["mobileNav", "navIconMenu", "navIconClose"];

  connect() {
    console.log("%c[nav-bar Controller] CONNECTED", "color: #1976D2");
  }

  // disconnect() {
  //   console.warn('[LegacyNavBar Controller] dis-connected');
  // }

  showMobileNav(event) {
    event.preventDefault();
    $(this.mobileNavTarget).removeClass("job-header__actions--hidden");
    $(this.navIconMenuTarget).addClass("job-nav-icon--hidden");
    $(this.navIconCloseTarget).removeClass("job-nav-icon--hidden");
    // $("body").addClass("no-scroll");
  }

  hideMobileNav(event) {
    event.preventDefault();
    $(this.mobileNavTarget).addClass("job-header__actions--hidden");
    $(this.navIconMenuTarget).removeClass("job-nav-icon--hidden");
    $(this.navIconCloseTarget).addClass("job-nav-icon--hidden");
    // $("body").removeClass("no-scroll");
  }
}
